import { createFileRoute } from '@tanstack/react-router'
import { requireAdminOrSuperAdmin } from '@/lib/auth-guards'
import { ExitLimitCheckInsTab } from '@/features/dashboard/tabs/exit-limit-check-ins-tab'

export const Route = createFileRoute(
  '/_authenticated/dashboard/exit-limit-check-ins'
)({
  beforeLoad: requireAdminOrSuperAdmin,
  component: ExitLimitCheckInsTab,
})
